import { defineMessage } from 'react-intl'

export const POINTS_MESSAGE = defineMessage({
    defaultMessage: '{points, plural, one {# point} other {# points}}',
    description: 'formatted number of activity points'
})
